import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NxToolbarService } from './nx-toolbar.service';

@Component({
  selector: 'nx-toolbar',
  templateUrl: './nx-toolbar.component.html',
  styleUrls: ['./nx-toolbar.component.scss']
})
export class NxToolbarComponent implements OnInit {
  @Input() config: string;


  viewport: any;
  toolbar: any;
  quantity;
  badgeState;

  logoUrl: string;
  language_en: string;
  language_fr: string;

  constructor(
    private _toolbarService: NxToolbarService,
    private _location: Location,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.setLayoutColor();

    this._toolbarService.currentToolbar.subscribe(data => this.toolbar = data);
    this._toolbarService.currentViewport.subscribe(data => this.viewport = data);

    this.getDynamicStyles()
    // this.getBadge();
  }

  setLayoutColor(): void {
    if (this.config == 'white') {
      this.logoUrl = '../assets/images/logo.png';
      this.language_en = './assets/icons/language_english.png';
      this.language_fr = './assets/icons/language_french.png';
    }
    else if (this.config == 'black') {
      this.logoUrl = '../assets/images/logo_white.png';
      this.language_en = './assets/icons/language_english_white.png';
      this.language_fr = './assets/icons/language_french_white.png';
    }
  }

  getDynamicStyles() {
    // console.log(this.viewport);
    let isMobile = true;
    if (this.viewport.name == 'lg' || this.viewport.name == 'xl') {
      isMobile = false;
    }

    return {
      'height' : isMobile ? '56px' : '80px'
    }
  }

  getBadge() {
    
  //   this._cartService.totalQuantity.subscribe( total => {
  //     this.quantity= total;
  //     // console.log('badge', this.quantity)
  //     let num = this.quantity;
  //     let string = num.toString();
  //     // console.log('badge string', string)
  //     sessionStorage.setItem('order', string)
  //   });

  //   if(this.quantity === undefined){
  //     let getOrder = sessionStorage.getItem('order')
  //     this.quantity = Number(getOrder);
  //   }
    
  }

  drawerToggle() {
    
  }

  back() {
    this._router.navigate([this.toolbar.link]);
  }

  close() {
    this._location.back();
  }

  lang_en() {
    this.toolbar.i18n = "en";
    this._toolbarService.updateToolbar(this.toolbar)
  }

  lang_fr() {
    this.toolbar.i18n = "fr";
    this._toolbarService.updateToolbar(this.toolbar)
  }

  viewMenu() {
    this._router.navigate(['/menu/list']);   
  }
  orderView() {
    this._router.navigate(['/order']);    
  }

  cartView() {
    this._router.navigate(['/cart']);   
  }

}
